import { gql } from 'graphql-request'

export const GetCreditorHistoryGql = gql`
  query listCreditorHistory(
    $stationRecordNumber: String!
    $toPaymentDate: LocalDate
    $fromPaymentDate: LocalDate
  ) {
    listCreditorHistory(
      request: {
        stationRecordNumber: $stationRecordNumber
        fromPaymentDate: $fromPaymentDate
        toPaymentDate: $toPaymentDate
      }
    ) {
      results {
        saleAndSeason
        paymentDate
        grossProceedsExGST
        netProceedsGSTInclusive
        totalBalesInPayment
        totalNetKgInPayment
      }
      sumOfGrossProceedsExGST
      sumOfNetProceedsGSTInclusive
      sumOfTotalBales
      sumOfTotalNetKg
    }
  }
`
